import {
    faSolidAnchor,
    faSolidAnchorCircleCheck,
    faSolidAngleLeft,
    faSolidAngleRight,
    faSolidAngleUp,
    faSolidAnglesLeft,
    faSolidAnglesRight,
    faSolidArrowDown,
    faSolidArrowLeftLong,
    faSolidArrowRightArrowLeft,
    faSolidArrowRightFromBracket,
    faSolidArrowRightToBracket,
    faSolidArrowRotateLeft,
    faSolidArrowsRotate,
    faSolidArrowsTurnToDots,
    faSolidBan,
    faSolidBars,
    faSolidBatteryEmpty,
    faSolidBatteryFull,
    faSolidBell,
    faSolidBellSlash,
    faSolidBook,
    faSolidBox,
    faSolidBoxArchive,
    faSolidBoxOpen,
    faSolidBoxesStacked,
    faSolidBuilding,
    faSolidBullhorn,
    faSolidCalendarCheck,
    faSolidCar,
    faSolidCaretDown,
    faSolidCaretUp,
    faSolidChartBar,
    faSolidCheck,
    faSolidCircle,
    faSolidCircleArrowRight,
    faSolidCircleCheck,
    faSolidCircleDot,
    faSolidCircleExclamation,
    faSolidCircleInfo,
    faSolidCircleQuestion,
    faSolidCircleUser,
    faSolidCircleXmark,
    faSolidClipboardList,
    faSolidClock,
    faSolidClockRotateLeft,
    faSolidClone,
    faSolidCloudSun,
    faSolidCompress,
    faSolidCopy,
    faSolidCube,
    faSolidDatabase,
    faSolidDownload,
    faSolidEnvelope,
    faSolidEnvelopeCircleCheck,
    faSolidEnvelopeOpen,
    faSolidExclamation,
    faSolidExpand,
    faSolidEye,
    faSolidFile,
    faSolidFileContract,
    faSolidFileCsv,
    faSolidFileExcel,
    faSolidFileInvoiceDollar,
    faSolidFileLines,
    faSolidFilePdf,
    faSolidFilter,
    faSolidFilterCircleXmark,
    faSolidFire,
    faSolidFireFlameCurved,
    faSolidFloppyDisk,
    faSolidGasPump,
    faSolidGauge,
    faSolidGear,
    faSolidHouse,
    faSolidHouseFloodWater,
    faSolidInbox,
    faSolidKey,
    faSolidLanguage,
    faSolidLightbulb,
    faSolidList,
    faSolidListCheck,
    faSolidLocationArrow,
    faSolidLocationDot,
    faSolidMagnifyingGlass,
    faSolidMagnifyingGlassLocation,
    faSolidMagnifyingGlassPlus,
    faSolidMapLocationDot,
    faSolidMinus,
    faSolidMoon,
    faSolidPaperclip,
    faSolidPassport,
    faSolidPause,
    faSolidPenToSquare,
    faSolidPersonMilitaryPointing,
    faSolidPlaneArrival,
    faSolidPlaneDeparture,
    faSolidPlay,
    faSolidPlus,
    faSolidPrint,
    faSolidQuestion,
    faSolidRectangleList,
    faSolidRecycle,
    faSolidScrewdriverWrench,
    faSolidShare,
    faSolidShieldHalved,
    faSolidShip,
    faSolidStopwatch,
    faSolidSun,
    faSolidTableColumns,
    faSolidTags,
    faSolidThumbsDown,
    faSolidThumbsUp,
    faSolidThumbtack,
    faSolidTrain,
    faSolidTrash,
    faSolidTriangleExclamation,
    faSolidTruck,
    faSolidTruckRampBox,
    faSolidUpload,
    faSolidUser,
    faSolidUserPlus,
    faSolidUserXmark,
    faSolidUsers,
    faSolidWandMagicSparkles,
    faSolidWarehouse,
    faSolidWind,
    faSolidXmark
} from '@ng-icons/font-awesome/solid';

import {
    bootstrapApple,
    bootstrapDashLg,
    bootstrapFacebook,
    bootstrapGoogle,
    bootstrapLockFill,
    bootstrapPinMapFill,
    bootstrapUnlockFill
} from '@ng-icons/bootstrap-icons';

import {
    flagAd,
    flagAe,
    flagAf,
    flagAg,
    flagAi,
    flagAl,
    flagAm,
    flagAo,
    flagAq,
    flagAr,
    flagArab,
    flagAs,
    flagAsean,
    flagAt,
    flagAu,
    flagAw,
    flagAx,
    flagAz,
    flagBa,
    flagBb,
    flagBd,
    flagBe,
    flagBf,
    flagBg,
    flagBh,
    flagBi,
    flagBj,
    flagBl,
    flagBm,
    flagBn,
    flagBo,
    flagBq,
    flagBr,
    flagBs,
    flagBt,
    flagBv,
    flagBw,
    flagBy,
    flagBz,
    flagCa,
    flagCc,
    flagCd,
    flagCefta,
    flagCf,
    flagCg,
    flagCh,
    flagCi,
    flagCk,
    flagCl,
    flagCm,
    flagCn,
    flagCo,
    flagCp,
    flagCr,
    flagCu,
    flagCv,
    flagCw,
    flagCx,
    flagCy,
    flagCz,
    flagDe,
    flagDg,
    flagDj,
    flagDk,
    flagDm,
    flagDo,
    flagDz,
    flagEac,
    flagEc,
    flagEe,
    flagEg,
    flagEh,
    flagEr,
    flagEs,
    flagEsCt,
    flagEsGa,
    flagEsPv,
    flagEt,
    flagEu,
    flagFi,
    flagFj,
    flagFk,
    flagFm,
    flagFo,
    flagFr,
    flagGa,
    flagGb,
    flagGbEng,
    flagGbNir,
    flagGbSct,
    flagGbWls,
    flagGd,
    flagGe,
    flagGf,
    flagGg,
    flagGh,
    flagGi,
    flagGl,
    flagGm,
    flagGn,
    flagGp,
    flagGq,
    flagGr,
    flagGs,
    flagGt,
    flagGu,
    flagGw,
    flagGy,
    flagHk,
    flagHm,
    flagHn,
    flagHr,
    flagHt,
    flagHu,
    flagIc,
    flagId,
    flagIe,
    flagIl,
    flagIm,
    flagIn,
    flagIo,
    flagIq,
    flagIr,
    flagIs,
    flagIt,
    flagJe,
    flagJm,
    flagJo,
    flagJp,
    flagKe,
    flagKg,
    flagKh,
    flagKi,
    flagKm,
    flagKn,
    flagKp,
    flagKr,
    flagKw,
    flagKy,
    flagKz,
    flagLa,
    flagLb,
    flagLc,
    flagLi,
    flagLk,
    flagLr,
    flagLs,
    flagLt,
    flagLu,
    flagLv,
    flagLy,
    flagMa,
    flagMc,
    flagMd,
    flagMe,
    flagMf,
    flagMg,
    flagMh,
    flagMk,
    flagMl,
    flagMm,
    flagMn,
    flagMo,
    flagMp,
    flagMq,
    flagMr,
    flagMs,
    flagMt,
    flagMu,
    flagMv,
    flagMw,
    flagMx,
    flagMy,
    flagMz,
    flagNa,
    flagNc,
    flagNe,
    flagNf,
    flagNg,
    flagNi,
    flagNl,
    flagNo,
    flagNp,
    flagNr,
    flagNu,
    flagNz,
    flagOm,
    flagPa,
    flagPc,
    flagPe,
    flagPf,
    flagPg,
    flagPh,
    flagPk,
    flagPl,
    flagPm,
    flagPn,
    flagPr,
    flagPs,
    flagPt,
    flagPw,
    flagPy,
    flagQa,
    flagRe,
    flagRo,
    flagRs,
    flagRu,
    flagRw,
    flagSa,
    flagSb,
    flagSc,
    flagSd,
    flagSe,
    flagSg,
    flagSh,
    flagShAc,
    flagShHl,
    flagShTa,
    flagSi,
    flagSj,
    flagSk,
    flagSl,
    flagSm,
    flagSn,
    flagSo,
    flagSr,
    flagSs,
    flagSt,
    flagSv,
    flagSx,
    flagSy,
    flagSz,
    flagTc,
    flagTd,
    flagTf,
    flagTg,
    flagTh,
    flagTj,
    flagTk,
    flagTl,
    flagTm,
    flagTn,
    flagTo,
    flagTr,
    flagTt,
    flagTv,
    flagTw,
    flagTz,
    flagUa,
    flagUg,
    flagUm,
    flagUn,
    flagUs,
    flagUy,
    flagUz,
    flagVa,
    flagVc,
    flagVe,
    flagVg,
    flagVi,
    flagVn,
    flagVu,
    flagWf,
    flagWs,
    flagXk,
    flagXx,
    flagYe,
    flagYt,
    flagZa,
    flagZm,
    flagZw
} from '@ng-icons/flag-icons';

const icons: Record<string, string> = {
    bootstrapApple,
    bootstrapFacebook,
    bootstrapPinMapFill,
    bootstrapGoogle,
    bootstrapLockFill,
    bootstrapUnlockFill,
    bootstrapDashLg,
    faSolidClock,
    faSolidLocationArrow,
    faSolidAnchor,
    faSolidAngleLeft,
    faSolidCloudSun,
    faSolidAngleRight,
    faSolidAnglesLeft,
    faSolidAnglesRight,
    faSolidAngleUp,
    faSolidArrowRightArrowLeft,
    faSolidArrowRightFromBracket,
    faSolidArrowRightToBracket,
    faSolidArrowRotateLeft,
    faSolidArrowsRotate,
    faSolidArrowsTurnToDots,
    faSolidBan,
    faSolidBars,
    faSolidBatteryEmpty,
    faSolidRectangleList,
    faSolidBatteryFull,
    faSolidBell,
    faSolidBellSlash,
    faSolidBook,
    faSolidBox,
    faSolidBoxArchive,
    faSolidBoxOpen,
    faSolidBoxesStacked,
    faSolidBuilding,
    faSolidBullhorn,
    faSolidCar,
    faSolidCaretDown,
    faSolidCaretUp,
    faSolidChartBar,
    faSolidCheck,
    faSolidCircle,
    faSolidCircleCheck,
    faSolidCircleExclamation,
    faSolidCircleInfo,
    faSolidCircleQuestion,
    faSolidCircleUser,
    faSolidCalendarCheck,
    faSolidCircleXmark,
    faSolidClipboardList,
    faSolidArrowLeftLong,
    faSolidClone,
    faSolidMagnifyingGlassPlus,
    faSolidCompress,
    faSolidCube,
    faSolidDatabase,
    faSolidDownload,
    faSolidEnvelope,
    faSolidEnvelopeCircleCheck,
    faSolidEnvelopeOpen,
    faSolidExclamation,
    faSolidExpand,
    faSolidEye,
    faSolidFile,
    faSolidFileExcel,
    faSolidFileCsv,
    faSolidFileInvoiceDollar,
    faSolidFileLines,
    faSolidFilePdf,
    faSolidFilter,
    faSolidFilterCircleXmark,
    faSolidFire,
    faSolidFireFlameCurved,
    faSolidFloppyDisk,
    faSolidGauge,
    faSolidMagnifyingGlassLocation,
    faSolidGasPump,
    faSolidGear,
    faSolidHouse,
    faSolidInbox,
    faSolidKey,
    faSolidLanguage,
    faSolidLightbulb,
    faSolidList,
    faSolidListCheck,
    faSolidLocationDot,
    faSolidMagnifyingGlass,
    faSolidMapLocationDot,
    faSolidMinus,
    faSolidMoon,
    flagAg,
    flagAd,
    flagAe,
    flagAf,
    flagAi,
    flagAl,
    flagAm,
    flagAo,
    flagAq,
    flagAr,
    flagArab,
    flagAs,
    flagAsean,
    flagAt,
    flagAu,
    flagAw,
    flagAx,
    flagAz,
    flagBa,
    flagBb,
    flagBd,
    flagBe,
    flagBf,
    flagBg,
    flagBh,
    flagBi,
    flagBj,
    flagBl,
    flagBm,
    flagBn,
    flagBo,
    flagBq,
    flagBr,
    flagBs,
    flagBt,
    flagBv,
    flagBw,
    flagBy,
    flagBz,
    flagCa,
    flagCc,
    flagCd,
    flagCefta,
    flagCf,
    flagCg,
    flagCh,
    flagCi,
    flagCk,
    flagCl,
    flagCm,
    flagCn,
    flagCo,
    flagCp,
    flagCr,
    flagCu,
    flagCv,
    flagCw,
    flagCx,
    flagCy,
    flagCz,
    flagDe,
    flagDg,
    flagDj,
    flagDk,
    flagDm,
    flagDo,
    flagDz,
    flagEac,
    flagEc,
    flagEe,
    flagEg,
    flagEh,
    flagEr,
    flagEs,
    flagEsCt,
    flagEsGa,
    flagEsPv,
    flagEt,
    flagEu,
    flagFi,
    flagFj,
    flagFk,
    flagFm,
    flagFo,
    flagFr,
    flagGa,
    flagGb,
    flagGbEng,
    flagGbNir,
    flagGbSct,
    flagGbWls,
    flagGd,
    flagGe,
    flagGf,
    flagGg,
    flagGh,
    flagGi,
    flagGl,
    flagGm,
    flagGn,
    flagGp,
    flagGq,
    flagGr,
    flagGs,
    flagGt,
    flagGu,
    flagGw,
    flagGy,
    flagHk,
    flagHm,
    flagHn,
    flagHr,
    flagHt,
    flagHu,
    flagIc,
    flagId,
    flagIe,
    flagIl,
    flagIm,
    flagIn,
    flagIo,
    flagIq,
    flagIr,
    flagIs,
    flagIt,
    flagJe,
    flagJm,
    flagJo,
    flagJp,
    flagKe,
    flagKg,
    flagKh,
    flagKi,
    flagKm,
    flagKn,
    flagKp,
    flagKr,
    flagKw,
    flagKy,
    flagKz,
    flagLa,
    flagLb,
    flagLc,
    flagLi,
    flagLk,
    flagLr,
    flagLs,
    flagLt,
    flagLu,
    flagLv,
    flagLy,
    flagMa,
    flagMc,
    flagMd,
    flagMe,
    flagMf,
    flagMg,
    flagMh,
    flagMk,
    flagMl,
    flagMm,
    flagMn,
    flagMo,
    flagMp,
    flagMq,
    flagMr,
    flagMs,
    flagMt,
    flagMu,
    flagMv,
    flagMw,
    flagMx,
    flagMy,
    flagMz,
    flagNa,
    flagNc,
    flagNe,
    flagNf,
    flagNg,
    flagNi,
    flagNl,
    flagNo,
    flagNp,
    flagNr,
    flagNu,
    flagNz,
    flagOm,
    flagPa,
    flagPc,
    flagPe,
    flagPf,
    flagPg,
    flagPh,
    flagPk,
    flagPl,
    flagPm,
    flagPn,
    flagPr,
    flagPs,
    flagPt,
    flagPw,
    flagPy,
    flagQa,
    flagRe,
    flagRo,
    flagRs,
    flagRu,
    flagRw,
    flagSa,
    flagSb,
    flagSc,
    flagSd,
    flagSe,
    flagSg,
    flagSh,
    flagShAc,
    flagShHl,
    flagShTa,
    flagSi,
    flagSj,
    flagSk,
    flagSl,
    flagSm,
    flagSn,
    flagSo,
    flagSr,
    flagSs,
    flagSt,
    flagSv,
    flagSx,
    flagSy,
    flagSz,
    flagTc,
    flagTd,
    flagTf,
    flagTg,
    flagTh,
    flagTj,
    flagTk,
    flagTl,
    flagTm,
    flagTn,
    flagTo,
    flagTr,
    flagTt,
    flagTv,
    flagTw,
    flagTz,
    flagUa,
    flagUg,
    flagUm,
    flagUn,
    flagUs,
    flagUy,
    flagUz,
    flagVa,
    flagVc,
    flagVe,
    flagVg,
    flagVi,
    flagVn,
    flagVu,
    flagWf,
    flagWs,
    flagXk,
    flagXx,
    flagYe,
    flagYt,
    flagZa,
    flagZm,
    flagZw,
    faSolidPaperclip,
    faSolidPassport,
    faSolidPause,
    faSolidPenToSquare,
    faSolidPersonMilitaryPointing,
    faSolidPlay,
    faSolidPlaneArrival,
    faSolidPlaneDeparture,
    faSolidPlus,
    faSolidPrint,
    faSolidRecycle,
    faSolidHouseFloodWater,
    faSolidQuestion,
    faSolidScrewdriverWrench,
    faSolidShare,
    faSolidShieldHalved,
    faSolidClockRotateLeft,
    faSolidShip,
    faSolidSun,
    faSolidCircleDot,
    faSolidStopwatch,
    faSolidTableColumns,
    faSolidTags,
    faSolidThumbsDown,
    faSolidThumbsUp,
    faSolidThumbtack,
    faSolidTrain,
    faSolidCircleArrowRight,
    faSolidAnchorCircleCheck,
    faSolidTriangleExclamation,
    faSolidFileContract,
    faSolidTrash,
    faSolidTruck,
    faSolidTruckRampBox,
    faSolidCopy,
    faSolidUpload,
    faSolidUser,
    faSolidUserPlus,
    faSolidUsers,
    faSolidUserXmark,
    faSolidArrowDown,
    faSolidWandMagicSparkles,
    faSolidWind,
    faSolidWarehouse,
    faSolidXmark
};

export default icons;

export type IconKey =
    | 'bootstrapApple'
    | 'bootstrapPinMapFill'
    | 'bootstrapFacebook'
    | 'bootstrapGoogle'
    | 'bootstrapLockFill'
    | 'bootstrapUnlockFill'
    | 'bootstrapDashLg'
    | 'faClock'
    | 'faSolidLocationArrow'
    | 'faSolidAnchor'
    | 'faSolidCircleArrowRight'
    | 'faSolidAnchorCircleCheck'
    | 'faSolidAngleLeft'
    | 'faSolidClockRotateLeft'
    | 'faSolidAngleRight'
    | 'faSolidAnglesLeft'
    | 'faSolidCopy'
    | 'faSolidAnglesRight'
    | 'faSolidCloudSun'
    | 'faSolidAngleUp'
    | 'faSolidCircleDot'
    | 'faSolidArrowRightArrowLeft'
    | 'faSolidArrowRightFromBracket'
    | 'faSolidArrowRightToBracket'
    | 'faSolidArrowRotateLeft'
    | 'faSolidArrowsRotate'
    | 'faSolidMagnifyingGlassPlus'
    | 'faSolidArrowsTurnToDots'
    | 'faSolidBan'
    | 'faSolidBars'
    | 'faSolidClock'
    | 'faSolidBatteryEmpty'
    | 'faSolidArrowDown'
    | 'faSolidRectangleList'
    | 'faSolidBatteryFull'
    | 'faSolidBell'
    | 'faSolidBellSlash'
    | 'faSolidBook'
    | 'faSolidBox'
    | 'faSolidBoxArchive'
    | 'faSolidBoxOpen'
    | 'faSolidBoxesStacked'
    | 'faSolidTriangleExclamation'
    | 'flagAg'
    | 'flagAd'
    | 'flagAe'
    | 'flagAf'
    | 'flagAi'
    | 'flagAl'
    | 'flagAm'
    | 'flagAo'
    | 'flagAq'
    | 'flagAr'
    | 'flagArab'
    | 'flagAs'
    | 'flagAsean'
    | 'flagAt'
    | 'flagAu'
    | 'flagAw'
    | 'flagAx'
    | 'flagAz'
    | 'flagBa'
    | 'flagBb'
    | 'flagBd'
    | 'flagBe'
    | 'flagBf'
    | 'flagBg'
    | 'flagBh'
    | 'flagBi'
    | 'flagBj'
    | 'flagBl'
    | 'flagBm'
    | 'flagBn'
    | 'flagBo'
    | 'flagBq'
    | 'flagBr'
    | 'flagBs'
    | 'flagBt'
    | 'flagBv'
    | 'flagBw'
    | 'flagBy'
    | 'flagBz'
    | 'flagCa'
    | 'flagCc'
    | 'flagCd'
    | 'flagCefta'
    | 'flagCf'
    | 'flagCg'
    | 'flagCh'
    | 'flagCi'
    | 'flagCk'
    | 'flagCl'
    | 'flagCm'
    | 'flagCn'
    | 'flagCo'
    | 'flagCp'
    | 'flagCr'
    | 'flagCu'
    | 'flagCv'
    | 'flagCw'
    | 'flagCx'
    | 'flagCy'
    | 'flagCz'
    | 'flagDe'
    | 'flagDg'
    | 'flagDj'
    | 'flagDk'
    | 'flagDm'
    | 'flagDo'
    | 'flagDz'
    | 'flagEac'
    | 'flagEc'
    | 'flagEe'
    | 'flagEg'
    | 'flagEh'
    | 'flagEr'
    | 'flagEs'
    | 'flagEsCt'
    | 'flagEsGa'
    | 'flagEsPv'
    | 'flagEt'
    | 'flagEu'
    | 'flagFi'
    | 'flagFj'
    | 'flagFk'
    | 'flagFm'
    | 'flagFo'
    | 'flagFr'
    | 'flagGa'
    | 'flagGb'
    | 'flagGbEng'
    | 'flagGbNir'
    | 'flagGbSct'
    | 'flagGbWls'
    | 'flagGd'
    | 'flagGe'
    | 'flagGf'
    | 'flagGg'
    | 'flagGh'
    | 'flagGi'
    | 'flagGl'
    | 'flagGm'
    | 'flagGn'
    | 'flagGp'
    | 'flagGq'
    | 'flagGr'
    | 'flagGs'
    | 'flagGt'
    | 'flagGu'
    | 'flagGw'
    | 'flagGy'
    | 'flagHk'
    | 'flagHm'
    | 'flagHn'
    | 'flagHr'
    | 'flagHt'
    | 'flagHu'
    | 'flagIc'
    | 'flagId'
    | 'flagIe'
    | 'flagIl'
    | 'flagIm'
    | 'flagIn'
    | 'flagIo'
    | 'flagIq'
    | 'flagIr'
    | 'flagIs'
    | 'flagIt'
    | 'flagJe'
    | 'flagJm'
    | 'flagJo'
    | 'flagJp'
    | 'flagKe'
    | 'flagKg'
    | 'flagKh'
    | 'flagKi'
    | 'flagKm'
    | 'flagKn'
    | 'flagKp'
    | 'flagKr'
    | 'flagKw'
    | 'flagKy'
    | 'flagKz'
    | 'flagLa'
    | 'flagLb'
    | 'flagLc'
    | 'flagLi'
    | 'flagLk'
    | 'flagLr'
    | 'flagLs'
    | 'flagLt'
    | 'flagLu'
    | 'flagLv'
    | 'flagLy'
    | 'flagMa'
    | 'flagMc'
    | 'flagMd'
    | 'flagMe'
    | 'flagMf'
    | 'flagMg'
    | 'flagMh'
    | 'flagMk'
    | 'flagMl'
    | 'flagMm'
    | 'flagMn'
    | 'flagMo'
    | 'flagMp'
    | 'flagMq'
    | 'flagMr'
    | 'flagMs'
    | 'flagMt'
    | 'flagMu'
    | 'flagMv'
    | 'flagMw'
    | 'flagMx'
    | 'flagMy'
    | 'flagMz'
    | 'flagNa'
    | 'flagNc'
    | 'flagNe'
    | 'flagNf'
    | 'flagNg'
    | 'flagNi'
    | 'flagNl'
    | 'flagNo'
    | 'flagNp'
    | 'flagNr'
    | 'flagNu'
    | 'flagNz'
    | 'flagOm'
    | 'flagPa'
    | 'flagPc'
    | 'flagPe'
    | 'flagPf'
    | 'flagPg'
    | 'flagPh'
    | 'flagPk'
    | 'flagPl'
    | 'flagPm'
    | 'flagPn'
    | 'flagPr'
    | 'flagPs'
    | 'flagPt'
    | 'flagPw'
    | 'flagPy'
    | 'flagQa'
    | 'flagRe'
    | 'flagRo'
    | 'flagRs'
    | 'flagRu'
    | 'flagRw'
    | 'flagSa'
    | 'flagSb'
    | 'flagSc'
    | 'flagSd'
    | 'flagSe'
    | 'flagSg'
    | 'flagSh'
    | 'flagShAc'
    | 'flagShHl'
    | 'flagShTa'
    | 'flagSi'
    | 'flagSj'
    | 'flagSk'
    | 'flagSl'
    | 'flagSm'
    | 'flagSn'
    | 'flagSo'
    | 'flagSr'
    | 'flagSs'
    | 'flagSt'
    | 'flagSv'
    | 'flagSx'
    | 'flagSy'
    | 'flagSz'
    | 'flagTc'
    | 'flagTd'
    | 'flagTf'
    | 'flagTg'
    | 'flagTh'
    | 'flagTj'
    | 'flagTk'
    | 'flagTl'
    | 'flagTm'
    | 'flagTn'
    | 'flagTo'
    | 'flagTr'
    | 'flagTt'
    | 'flagTv'
    | 'flagTw'
    | 'flagTz'
    | 'flagUa'
    | 'flagUg'
    | 'flagUm'
    | 'flagUn'
    | 'flagUs'
    | 'flagUy'
    | 'flagUz'
    | 'flagVa'
    | 'flagVc'
    | 'flagVe'
    | 'flagVg'
    | 'flagVi'
    | 'flagVn'
    | 'flagVu'
    | 'flagWf'
    | 'flagWs'
    | 'flagXk'
    | 'flagXx'
    | 'flagYe'
    | 'flagYt'
    | 'flagZa'
    | 'flagZm'
    | 'flagZw'
    | 'faSolidBuilding'
    | 'faSolidBullhorn'
    | 'faSolidCar'
    | 'faSolidCaretDown'
    | 'faSolidCaretUp'
    | 'faSolidChartBar'
    | 'faSolidCheck'
    | 'faSolidCircle'
    | 'faSolidCircleCheck'
    | 'faSolidCircleExclamation'
    | 'faSolidCircleInfo'
    | 'faSolidCircleQuestion'
    | 'faSolidCircleUser'
    | 'faSolidCalendarCheck'
    | 'faSolidCircleXmark'
    | 'faSolidClipboardList'
    | 'faSolidClone'
    | 'faSolidArrowLeftLong'
    | 'faSolidCompress'
    | 'faSolidCube'
    | 'faSolidDatabase'
    | 'faSolidDownload'
    | 'faSolidEnvelope'
    | 'faSolidEnvelopeCircleCheck'
    | 'faSolidEnvelopeOpen'
    | 'faSolidExclamation'
    | 'faSolidMagnifyingGlassLocation'
    | 'faSolidExpand'
    | 'faSolidEye'
    | 'faSolidFile'
    | 'faSolidFileExcel'
    | 'faSolidFileCsv'
    | 'faSolidFileInvoiceDollar'
    | 'faSolidFileLines'
    | 'faSolidFilePdf'
    | 'faSolidFilter'
    | 'faSolidFilterCircleXmark'
    | 'faSolidFire'
    | 'faSolidFireFlameCurved'
    | 'faSolidFloppyDisk'
    | 'faSolidGauge'
    | 'faSolidGasPump'
    | 'faSolidGear'
    | 'faSolidHouse'
    | 'faSolidInbox'
    | 'faSolidKey'
    | 'faSolidLanguage'
    | 'faSolidLightbulb'
    | 'faSolidList'
    | 'faSolidListCheck'
    | 'faSolidLocationDot'
    | 'faSolidMagnifyingGlass'
    | 'faSolidMapLocationDot'
    | 'faSolidMinus'
    | 'faSolidMoon'
    | 'faSolidPaperclip'
    | 'faSolidPassport'
    | 'faSolidPause'
    | 'faSolidPenToSquare'
    | 'faSolidHouseFloodWater'
    | 'faSolidPersonMilitaryPointing'
    | 'faSolidPlay'
    | 'faSolidPlaneArrival'
    | 'faSolidPlaneDeparture'
    | 'faSolidPlus'
    | 'faSolidPrint'
    | 'faSolidRecycle'
    | 'faSolidQuestion'
    | 'faSolidScrewdriverWrench'
    | 'faSolidShare'
    | 'faSolidShieldHalved'
    | 'faSolidShip'
    | 'faSolidStopwatch'
    | 'faSolidSun'
    | 'faSolidTableColumns'
    | 'faSolidTags'
    | 'faSolidThumbsDown'
    | 'faSolidThumbsUp'
    | 'faSolidThumbtack'
    | 'faSolidTrain'
    | 'faSolidFileContract'
    | 'faSolidTrash'
    | 'faSolidTruck'
    | 'faSolidTruckRampBox'
    | 'faSolidUpload'
    | 'faSolidUser'
    | 'faSolidUserPlus'
    | 'faSolidUserXmark'
    | 'faSolidUsers'
    | 'faSolidWandMagicSparkles'
    | 'faSolidWarehouse'
    | 'faSolidWind'
    | 'faSolidXmark';
